export default __webpack_public_path__ + "static/media/isChecked.e895dbda.svg";